export interface IMapPolygon {
  id: string;
  points: { x: number; y: number }[];
  name: string;
  isSelected: boolean;
  loading: boolean;
  borderSize: number;
  borderColor: string;
  infoWindowContent: JSX.Element | string;
}

export class MapPolygon implements IMapPolygon {
    /**
   *
   */
    constructor(
        id: string,
        points: { x: number; y: number },
        name: string,
        isSelected: boolean,
        loading: boolean,
        borderSize: number,
        borderColor: string,
        infoWindowContent: JSX.Element | string
    ) {}
  public id = "";
  public points: { x: number; y: number }[] = [];
  public name = "";
  public isSelected = false;
  public loading = false;
  public borderSize = 0;
  public borderColor = "";
  public infoWindowContent: null | string | JSX.Element = null;
}
